import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/Shubham1.png'
import Icon3 from '../../assest/images//Icon3.png';
import Icon8 from '../../assest/images//Icon8.png';
import eye from '../../assest/images/eye.png';
import CustomDropdown from '../common/CustomDropdown';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { FaEye } from "react-icons/fa";

const ShipmentList = () => {
  const [shipmentData, setShipmentData] = useState([]);
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
  const [filterColumn1, setFilterColumn1] = useState('');
  const [filterValue1, setFilterValue1] = useState('');
  const [filterColumn2, setFilterColumn2] = useState('');
  const [filterValue2, setFilterValue2] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [options, setOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [itemsPerPage] = useState(10); // Used to set items per page

  useEffect(() => {
    fetchShipmentData();
  }, []);




  useEffect(() => {
    const fetchEnumTypes = async () => {
      try {
        const response = await fetch(`${config.API_URL}/api/enumtype/shipment`);
        if (!response.ok) {
          throw new Error('Failed to fetch enum types');
        }
        const data = await response.json();
        setOptions(data.data);
      } catch (error) {
        console.error('Error fetching enum types:', error);
      }
    };

    fetchEnumTypes();
  }, []);

  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 16,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const logaction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const fetchShipmentData = async () => {
    ////logaction("fetchShipmentData(): Started");
    try {
      const response = await fetch(`${config.API_URL}/shipment/logistic/${selectedScpId}`);
      const data = await response.json();

      if (data && Array.isArray(data.shipmentData)) {
        ////logaction("fetchShipmentData(): List data fetched successfully");
        setShipmentData(data.shipmentData);
      } else {
        console.error('Unexpected response format:', data);
      }
    } catch (error) {
      console.error('Error fetching shipment data:', error);
    }
    ////logaction("fetchShipmentData(): Ended");
  };
  const handlePrintPDF = async (shipmentCode) => {
    //logaction("handlePrintPDF(): Started");

    try {
      const response = await fetch(`${config.API_URL}/api/shipmentpdf/${shipmentCode}`);
      const data = await response.json();

      if (!data.tableData || data.tableData.length === 0) {
        //logaction("handlePrintPDF(): No shipment data", true);
        return;
      }

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      /* ================= HEADER ================= */
      const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
      const logoJson = await logoRes.json();
      const imgData = logoJson.base64 || ShubhamImage;
      doc.addImage(imgData, "PNG", 10, 10, 40, 15);

      /* ================= PRINT META (SYNCED) ================= */
      const printedOn = new Date();

      const formattedDate = printedOn.toLocaleDateString("en-GB");

      const formattedTime = printedOn.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      const printedOnText = `${formattedDate} ${formattedTime}`;

      const pageWidth = doc.internal.pageSize.getWidth();
      const baseX = pageWidth - 58;
      const baseY = 20;

      const colonOffset = 16.5;
      const valueOffset = 18.5;

      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);

      // Printed On
      doc.text("Printed On", baseX, baseY);
      doc.text(":", baseX + colonOffset, baseY);
      doc.text(printedOnText, baseX + valueOffset, baseY);

      // // Printed By
      // doc.text("Printed By", baseX, baseY + 5);
      // doc.text(":", baseX + colonOffset, baseY + 5);
      // doc.text(UM_UserCode, baseX + valueOffset, baseY + 5);

      /* ================= DOCUMENT TITLE ================= */
      const titleY = 40;

      doc.setTextColor(54, 162, 235, 1);
      doc.setFontSize(21);
      doc.setFont(undefined, "bold");
      doc.text(
        "Picking List",
        doc.internal.pageSize.width / 2,
        titleY,
        { align: "center" }
      );

      // Reset styles after title
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");
      //41, 128, 185

      const marginX = 10;
      const tableWidth = pageWidth - marginX * 2;

      /* ================= SHIPMENT INFO ================= */

      const rawDate = data.shipmentDetails.SHPH_ShipmentDate;
      const formattedshipmentDate = rawDate ? rawDate.replace(/-/g, "/") : "";

      doc.autoTable({
        startY: 45,
        theme: "grid",
        margin: { left: marginX, right: marginX },

        body: [
          [
            {
              content: "Shipment Information",
              colSpan: 2,
              styles: {
                halign: "center",
                fillColor: [38, 90, 128],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                cellPadding: { top: 1, bottom: 1 },
              },
            },
          ],
          ["Shipment Type", data.shipmentDetails.SHPH_ShipmentType],
          ["Shipment Date", formattedshipmentDate],
          ["Shipment Code", shipmentCode],
          ["Logistic Party Name", data.shipmentDetails.LGCM_Name],
          ["Vehicle Number", data.shipmentDetails.LGCVM_VehicleNumber || "-"],
          [
            "Scanning Mode",
            data.shipmentDetails.SHPH_ByProductVendorScanMode === 1
              ? "Vendor"
              : "Product",
          ],
          ["Shipment Status", data.shipmentDetails.Description],
          ["Route for Shipment Location", data.shipmentDetails.RUTL_Name],
        ],

        styles: {
          fontSize: 10,
          cellPadding: 1,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
          halign: "center", // ✅ CENTER ALL CELLS
          valign: "middle", // optional: vertical center
        },

        columnStyles: {
          0: { cellWidth: tableWidth / 2, halign: "center" },
          1: { cellWidth: tableWidth / 2, halign: "center" },
        },
      });



      /* =====================================================
         STEP 1: GROUP BY SCP + PRODUCT (SUM SHIP QTY)
      ===================================================== */
      const groupedMap = {};

      data.tableData.forEach((row) => {
        const key = `${row.scpName}__${row.productId}`;

        if (!groupedMap[key]) {
          groupedMap[key] = {
            scpName: row.scpName,
            productName: row.productName,
            productCode: row.productCode,
            productId: row.productId,
            shipQty: 0,
            batches: [],
          };
        }

        groupedMap[key].shipQty += Number(row.shipQty);
      });

      /* =====================================================
         STEP 2: BUILD BATCH MAP
      ===================================================== */
      const batchMap = {};

      if (Array.isArray(data.batchDetails)) {
        data.batchDetails.forEach((b) => {
          const key = `${b.scpName}__${b.productId}`;
          if (!batchMap[key]) batchMap[key] = [];
          batchMap[key].push({
            batchName: b.batchName,
            batchQty: b.batchQty,
          });
        });
      }

      /* =====================================================
         STEP 3: ATTACH BATCHES
      ===================================================== */
      Object.values(groupedMap).forEach((group) => {
        const key = `${group.scpName}__${group.productId}`;
        group.batches = batchMap[key] || [];
      });

      /* =====================================================
         STEP 4: PREPARE PDF ROWS (ROWSPAN)
      ===================================================== */
      const pdfRows = [];
      let srNo = 1;

      Object.values(groupedMap).forEach((group) => {
        const batchCount = group.batches.length || 1;

        if (group.batches.length === 0) {
          pdfRows.push([
            srNo,
            group.scpName,
            group.productName,
            group.productCode,
            group.shipQty,
            "-",
            "-",
          ]);
        } else {
          group.batches.forEach((batch, index) => {
            if (index === 0) {
              pdfRows.push([
                { content: srNo, rowSpan: batchCount },
                { content: group.scpName, rowSpan: batchCount },
                { content: group.productName, rowSpan: batchCount },
                { content: group.productCode, rowSpan: batchCount },
                { content: group.shipQty, rowSpan: batchCount },
                batch.batchName,
                batch.batchQty,
              ]);
            } else {
              pdfRows.push([batch.batchName, batch.batchQty]);
            }
          });
        }

        srNo++;
      });

      /* =====================================================
         STEP 5: SHIPMENT DETAILS TABLE
      ===================================================== */
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 10,
        theme: "grid",
        margin: { left: marginX, right: marginX },
        head: [
          [
            "Sr. No.",
            "SCP Name",
            "Product Name",
            "Product Code",
            "Ship Quantity",
            "Batch Name",
            "Quantity",
          ],
        ],
        body: pdfRows,
        headStyles: {
          fillColor: [38, 90, 128],
          textColor: [255, 255, 255],
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
          fontSize: 10,
          halign: 'center',
        },
        styles: {
          fontSize: 10,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
          cellPadding: { top: 1, bottom: 1 },
          halign: 'center',
        },
      });

      // ================= SIGNATURE BLOCK =================
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");

      const leftMargin = 10;
      const rightMargin = 10;

      const startX = leftMargin;
      const usableWidth = pageWidth - leftMargin - rightMargin;

      // Column setup
      const col1 = 35;          // Printed / Checked / Verified label
      const colGap = 6;         // 🔥 Horizontal gap between columns

      const remainingWidth = usableWidth - col1 - (colGap * 2);
      const col2 = remainingWidth / 3; // Name
      const col3 = col2;               // Signature
      const col4 = col2;               // Date

      // Column X positions
      const col1X = startX;
      const col2X = col1X + col1;
      const col3X = col2X + col2 + colGap;
      const col4X = col3X + col3 + colGap;

      // Start Y position
      let y = doc.autoTable.previous.finalY + 20;

      // Vertical spacing
      const rowGap = 7;

      // ---------- HEADER ----------
      doc.text("Name", col2X + col2 / 2, y, { align: "center" });
      doc.text("Signature", col3X + col3 / 2, y, { align: "center" });
      doc.text("Date", col4X + col4 / 2, y, { align: "center" });

      y += rowGap;

      // ---------- ROW FUNCTION ----------
      const colonX = col1X + 20; // fixed vertical line for colon

      const drawRow = (label) => {
        // draw label WITHOUT colon
        doc.text(label, col1X, y);

        // draw colon at fixed position
        doc.text(":", colonX, y);

        // lines
        doc.line(col2X, y, col2X + col2, y);
        doc.line(col3X, y, col3X + col3, y);
        doc.line(col4X, y, col4X + col4, y);

        y += rowGap;
      };

      // ---------- ROWS ----------
      drawRow("Printed By");
      drawRow("Checked By");
      drawRow("Verified By");


      addFooter(doc);
      doc.save(`Picking_List_${shipmentCode}.pdf`);

      logAudit(
        "Shipment Outward Creation",
        `Picking List PDF generated for shipment ${shipmentCode}`,
        "-",
        "-"
      );

      //logaction(`handlePrintPDF(): PDF generated successfully ${shipmentCode}`);
    } catch (error) {
      console.error(error);
      //logaction("handlePrintPDF(): Error generating PDF", true);
    }
  };

  const addFooter = (doc) => {
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      // Go to page i
      doc.setPage(i);
      // Set text alignment to left
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text('Developed by : Shubham Automation Pvt. Ltd.', 10, doc.internal.pageSize.getHeight() - 10); // at left side of the page

      // Add page number to the right side of the page
      doc.text(`Page ${i} of ${totalPages}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
    }
  };

  const handleFilterColumn1Change = (event) => {
    //logaction("handleFilterColumn1Change(): Started");
    try {
      const selectedColumn = event.target.value;
      //logaction(`handleFilterColumn1Change(): Selected Column 1 is: ${selectedColumn}`);
      setFilterColumn1(selectedColumn);
      setFilterValue1(''); // Clear input field when column changes

      if (selectedColumn === filterColumn2) {
        setFilterColumn2('');
        setFilterValue2(''); // Clear Column 2's input if it was the same
      }

      setCurrentPage(1); // Reset currentPage when filters change
      //logaction("handleFilterColumn1Change(): Filter Column 1 change handled successfully");
    } catch (error) {
      //logaction("handleFilterColumn1Change(): Error handling Filter Column 1 change", true);
      console.error('Error handling Filter Column 1 change:', error);
    }
  };
  const handleFilterValue1Change = (event) => {
    //logaction("handleFilterValue1Change(): Started");
    try {
      setFilterValue1(event.target.value);
      setCurrentPage(1); // Reset currentPage when filters change
      //logaction("handleFilterValue1Change(): Filter Value 1 change handled successfully");
    } catch (error) {
      //logaction("handleFilterValue1Change(): Error handling Filter Value 1 change", true);
      console.error('Error handling Filter Value 1 change:', error);
    }
  };

  const handleFilterColumn2Change = (event) => {
    //logaction("handleFilterColumn2Change(): Started");
    try {
      const selectedColumn = event.target.value;
      //logaction(`handleFilterColumn2Change(): Selected Column 2 is: ${selectedColumn}`);

      setFilterColumn2(selectedColumn);
      setFilterValue2(''); // Clear input field when column changes

      if (selectedColumn === filterColumn1) {
        setFilterColumn1('');
        setFilterValue1(''); // Clear Column 1's input if it was the same
      }

      setCurrentPage(1); // Reset currentPage when filters change
      //logaction("handleFilterColumn2Change(): Filter Column 2 change handled successfully");
    } catch (error) {
      //logaction("handleFilterColumn2Change(): Error handling Filter Column 2 change", true);
      console.error('Error handling Filter Column 2 change:', error);
    }
  };
  const handleFilterValue2Change = (event) => {
    //logaction("handleFilterValue2Change(): Started");
    try {
      setFilterValue2(event.target.value);
      setCurrentPage(1); // Reset currentPage when filters change
      //logaction("handleFilterValue2Change(): Filter Value 2 change handled successfully");
    } catch (error) {
      //logaction("handleFilterValue2Change(): Error handling Filter Value 2 change", true);
      console.error('Error handling Filter Value 2 change:', error);
    }
  };

  const filterShipmentData = (shipment) => {
    //logaction("filterShipmentData(): Started");
    try {
      // Filter by Column 1
      if (filterColumn1 && filterValue1) {
        switch (filterColumn1) {
          case 'Shipment Code':
            if (!shipment.SHPH_ShipmentCode.toLowerCase().includes(filterValue1.toLowerCase())) return false;
            break;
          case 'Logistic Party Name':
            if (!shipment.LGCM_Name.toLowerCase().includes(filterValue1.toLowerCase())) return false;
            break;
          case 'Vehicle Number':
            if (!shipment.LGCVM_VehicleNumber.toLowerCase().includes(filterValue1.toLowerCase())) return false;
            break;
          default:
            break;
        }
      }

      // Filter by Column 2
      if (filterColumn2 && filterValue2) {
        switch (filterColumn2) {
          case 'Shipment Code':
            if (!shipment.SHPH_ShipmentCode.toLowerCase().includes(filterValue2.toLowerCase())) return false;
            break;
          case 'Logistic Party Name':
            if (!shipment.LGCM_Name.toLowerCase().includes(filterValue2.toLowerCase())) return false;
            break;
          case 'Vehicle Number':
            if (!shipment.LGCVM_VehicleNumber.toLowerCase().includes(filterValue2.toLowerCase())) return false;
            break;
          default:
            break;
        }
      }

      // Filter by Status
      if (selectedStatus && selectedStatus !== 'All') {
        console.log(`Filtering by Status: ${selectedStatus}`);
        console.log(`Comparing Status: ${shipment.SHPH_Status} === ${selectedStatus}`);
        if (shipment.SHPH_Status !== selectedStatus) {
          console.log('Status filter failed');
          return false;
        }
      }

      //logaction("filterShipmentData(): Shipment data filtered successfully");
      return true;
    } catch (error) {
      //logaction("filterShipmentData(): Error filtering shipment data", true);
      console.error('Error filtering shipment data:', error);
      return false;
    }
  };

  const handlestatuschange = (e) => {
    const newStatus = (e.target.value); // Ensure newStatus is treated as a string and trimmed
    console.log('New Status:', newStatus);
    setSelectedStatus(newStatus);
    //logaction(`HandleStatusChange(): ${newStatus}`);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [filterShipmentData.length]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  let currentItems = shipmentData.slice(indexOfFirstItem, indexOfLastItem);

  if (Array.isArray(shipmentData) && shipmentData.length) {
    const filteredShipments = shipmentData.filter(filterShipmentData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredShipments.slice(indexOfFirstItem, indexOfLastItem);
  }
  const paginate = (pageNumber) => {
    //logaction(`paginate(): Started for page number ${pageNumber}`);
    try {
      setCurrentPage(pageNumber);
      //logaction(`paginate(): Pagination handled successfully for page number ${pageNumber}`);
    } catch (error) {
      //logaction("paginate(): Error handling pagination", true);
      console.error('Error handling pagination:', error);
    }
  };

  return (
    <>
      <div className='main_container'>

        <h1 className="formHeading">Shipment Master</h1>
        <div className="filter-container">
          <div className='select-container_list'>
            <CustomDropdown
              options={[
                { id: "Shipment Code", name: "Shipment Code", disabled: filterColumn2 === "Shipment Code" },
                { id: "Logistic Party Name", name: "Logistic Party Name", disabled: filterColumn2 === "Logistic Party Name" },
                { id: "Vehicle Number", name: "Vehicle Number", disabled: filterColumn2 === "Vehicle Number" }
              ]}
              value={filterColumn1}
              onChange={handleFilterColumn1Change}
              name="filterColumn1"
              placeholder="--Select--"
              idKey="id"
              displayKey="name"
            />
          </div>

          <input
            type="text"
            className='search-input'

            placeholder={`Search`}
            value={filterValue1}
            onChange={handleFilterValue1Change}
          />
          <div className='select-container_list'>
            <CustomDropdown
              options={[
                { id: "Shipment Code", name: "Shipment Code", disabled: filterColumn1 === "Shipment Code" },
                { id: "Logistic Party Name", name: "Logistic Party Name", disabled: filterColumn1 === "Logistic Party Name" },
                { id: "Vehicle Number", name: "Vehicle Number", disabled: filterColumn1 === "Vehicle Number" }
              ]}
              value={filterColumn2}
              onChange={handleFilterColumn2Change}
              name="filterColumn2"
              placeholder="--Select--"
              idKey="id"
              displayKey="name"
            />
          </div>
          <input
            type="text"
            className='search-input'
            placeholder={`Search`}
            value={filterValue2}
            onChange={handleFilterValue2Change}
          />
          <div className='select-container_list'>
            <CustomDropdown
              options={options}
              value={selectedStatus}
              onChange={handlestatuschange}
              name="orderStatus"
              placeholder="--Select Status--"
              idKey="id"
              displayKey="name"
            />
          </div>

        </div>
        <div className="ptable-wrapper">
          <table className="ptableClass">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Shipment Code</th>
                <th scope="col">Logistic Party Name</th>
                <th scope="col">Vehicle Number</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="6">No Records Found</td>
                </tr>
              ) : (
                currentItems.map((shipment, index) => (
                  <tr key={shipment.SHPH_ShipmentCode}>
                    <td>{index + 1 + indexOfFirstItem}</td>
                    <td>{shipment.SHPH_ShipmentCode}</td>
                    <td>{shipment.LGCM_Name}</td>
                    <td>{shipment.LGCVM_VehicleNumber || "-"} </td>
                    <td>{shipment.StatusDescription === 'Reject' ? 'Rejected' : shipment.StatusDescription}</td>
                    <td>
                      {shipment.StatusDescription === 'Created' || shipment.StatusDescription === 'Approved' ? (
                        <>
                          <Link to={`/shipmentedit/${shipment.SHPH_ShipmentCode}`}>
                            <img title='Edit' src={Icon3} alt="Edit" className="editicon" />
                          </Link>
                        </>
                      ) :
                        (
                          <span>&ensp;&ensp;&ensp;</span>
                        )}
                      <Link to={`/shipmentview/${shipment.SHPH_ShipmentCode}`}>
                        <FaEye
                          title="View"
                          style={{
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: '#000000'
                          }}
                        />
                      </Link>
                      <img title='Print' src={Icon8} alt="Edit" onClick={() => handlePrintPDF(shipment.SHPH_ShipmentCode)} className="printicon" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
        <ul className="pagination">
          {/* First Page Button */}
          <li className={currentPage === 1 || shipmentData.filter(filterShipmentData).length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(1)} disabled={currentPage === 1 || shipmentData.filter(filterShipmentData).length === 0}>First</button>
          </li>

          {/* Previous Page Button */}
          <li className={currentPage === 1 || shipmentData.filter(filterShipmentData).length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1 || shipmentData.filter(filterShipmentData).length === 0}>Previous</button>
          </li>

          {/* Page Numbers */}
          {shipmentData.filter(filterShipmentData).length > 0 &&
            Array.from({ length: Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage) }, (_, index) => (
              <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
              </li>
            ))
          }

          {/* Next Page Button */}
          <li className={currentPage === Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage) || shipmentData.filter(filterShipmentData).length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage) || shipmentData.filter(filterShipmentData).length === 0}>Next</button>
          </li>

          {/* Last Page Button */}
          <li className={currentPage === Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage) || shipmentData.filter(filterShipmentData).length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage))} disabled={currentPage === Math.ceil(shipmentData.filter(filterShipmentData).length / itemsPerPage) || shipmentData.filter(filterShipmentData).length === 0}>Last</button>
          </li>
        </ul>

      </div>
      <Link to={`/dashboard/shipment`} className="back_btn">
        BACK
      </Link>
    </>
  );
};

export default ShipmentList;